import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EnrollmentService } from '../../../../../../app/services/enrollment.service';
import { CreateUserModel } from '../../../../../../app/models/createUserModel';
import { CreateUserResult } from '../../../../../../app/models/createUserResult';
import { SnackbarService } from '../../../../../services/snackbar.service';
import { TranslocoService } from '@jsverse/transloco';
import { MyConfigService } from '../../../../../../app/services/my-config.service';

@Component({
  selector: 'app-back-office24-users-add',
  standalone: false,
  templateUrl: './back-office24-users-add.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './back-office24-users-add.component.css'
})
export class BackOffice24UsersAddComponent {
  @Output() saveChangesEvent = new EventEmitter<any>();
  userForm: UntypedFormGroup;
  isLoading: boolean = false;
  organizationMemberTypes: any[];
  memberShipTypes: any[] = [];
  loading: boolean = false;
  createUserModel: CreateUserModel;
  languages = [{ value: 'svenska', viewValue: 'Svenska' }, { value: 'english', viewValue: 'English' }];

  constructor(
    private enrollmentService: EnrollmentService,
    private formBuilder: FormBuilder,
    private _snackBar: SnackbarService,
    private translate: TranslocoService,
    @Inject(MatDialogRef<BackOffice24UsersAddComponent>) private dialogRef: MatDialogRef<BackOffice24UsersAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      organizationId: string,
      targetOrganizationId?: string,
      organizationMemberTypes?: any[],
      parkingMemberTypes?: any[],
      orgType?: any
    },
    private myConfigService: MyConfigService
  ) {
  }

  ngOnInit(): void {
    this.emptyUserForm();
    this.organizationMemberTypes = this.data?.organizationMemberTypes;
    const config = this.myConfigService.getMyConfig();
    const currentOrg = config?.organizations?.find(org =>
      org.organizationId === this.data?.organizationId
    );
    if(this.data?.orgType === "ParkingCompany"){
      this.memberShipTypes = this.data?.parkingMemberTypes;
    }else {
      const userMembershipRight = currentOrg?.memberShipRight || 0;
      const matchingMemberTypes = this.getMatchingMemberTypes(Number(userMembershipRight));
      this.memberShipTypes = matchingMemberTypes?.length > 0 ? matchingMemberTypes : this.organizationMemberTypes;
    }
  }

  getMatchingMemberTypes(membershipRight: number): any[] {
    return this.organizationMemberTypes.filter(memberType =>
      memberType.id > 0 && (membershipRight & memberType.id) === memberType.id
    );
  }

  emptyUserForm() {
    this.userForm = this.formBuilder.group({
      organizationId: this.data.organizationId,
      firstname: [{ value: '', disabled: this.isLoading }, [Validators.required]],
      language: [{ value: 'english', disabled: this.isLoading }, [Validators.required]],
      lastname: [{ value: '', disabled: this.isLoading }, [Validators.required]],
      email: [{ value: '', disabled: this.isLoading }, [Validators.required, Validators.email]],
      cellphone: [{ value: '', disabled: this.isLoading }, [Validators.required]],
      smsVerification: [{ value: false, disabled: this.isLoading }],
      membershipType: [{ value: [], disabled: this.isLoading }]
    });
  }

  saveChanges(): void {
    if (this.userForm.invalid) {
      return;
    }

    this.isLoading = true;

    const model: any = {
      organizationId: this.data.organizationId,
      targetOrganizationId: this.data.targetOrganizationId,
      firstname: this.userForm.get('firstname')?.value,
      lastname: this.userForm.get('lastname')?.value,
      language: this.userForm.get('language')?.value,
      email: this.userForm.get('email')?.value,
      mobile: this.userForm.get('cellphone')?.value,
      smsVerification: this.userForm.get('smsVerification')?.value,
      targetMembershipType: (this.userForm.get('membershipType')?.value || []).reduce((sum, val) => sum | val, 0)
    };

    this.enrollmentService
      .createUser(
        model.email,
        model.firstname,
        model.lastname,
        model.language,
        model.organizationId,
        model.targetOrganizationId,
        model.mobile,
        model.smsVerification,
        model.targetMembershipType
      )
      .subscribe({
        next: (result: CreateUserResult) => {
          if (result) {
            const message = this.translate.translate('USER_MANAGEMENT.USER_CREATED');
            this.createUserModel = new CreateUserModel(null);
            this._snackBar.openSnackBar(message, 'OK');
            this.saveChangesEvent.emit({ userAdded: true, user: result });
          } else {
            const message = this.translate.translate('USER_MANAGEMENT.CHECK_DETAILS');
            this._snackBar.openSnackBar(message, 'OK');
            this.saveChangesEvent.emit({ userAdded: false });
          }
          this.loading = false;
        },
        error: (error: any) => {
          this.loading = false;
          console.log(error);
          const message = this.translate.translate('USER_MANAGEMENT.SOMETHING_WRONG');
          this._snackBar.openSnackBar(message, 'OK');
        }
      });

    this.dialogRef.close();

  }
}

